import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteLayout } from "@/components/site/SiteLayout";
import { AppLayout } from "@/components/portal/AppLayout";
import { Spinner } from "@/components/portal/ui";

import Home from "@/pages/site/Home";
import About from "@/pages/site/About";
import Services from "@/pages/site/Services";
import Industries from "@/pages/site/Industries";
import Warehousing from "@/pages/site/Warehousing";
import CrossBorder from "@/pages/site/CrossBorder";
import Sustainability from "@/pages/site/Sustainability";
import Contact from "@/pages/site/Contact";
import Track from "@/pages/site/Track";
import Quote from "@/pages/site/Quote";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import PaymentResult from "@/pages/site/PaymentResult";
import PayLink from "@/pages/site/PayLink";

import Dashboard from "@/pages/app/Dashboard";
import Shipments from "@/pages/app/Shipments";
import ShipmentDetail from "@/pages/app/ShipmentDetail";
import Quotes from "@/pages/app/Quotes";
import Invoices from "@/pages/app/Invoices";
import Locations from "@/pages/app/Locations";
import ControlTower from "@/pages/app/ControlTower";
import Executive from "@/pages/app/Executive";
import Fleet from "@/pages/app/Fleet";
import WarehouseOps from "@/pages/app/WarehouseOps";
import Finance from "@/pages/app/Finance";
import CrossBorderOps from "@/pages/app/CrossBorderOps";
import SustainabilityOps from "@/pages/app/SustainabilityOps";
import ErpConsole from "@/pages/app/ErpConsole";
import Admin from "@/pages/app/Admin";
import Driver from "@/pages/app/Driver";
import RouteAI from "@/pages/app/RouteAI";
import Customs from "@/pages/app/Customs";
import Alerts from "@/pages/app/Alerts";

function site(el) {
  return <SiteLayout>{el}</SiteLayout>;
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function AppHome() {
  const { isStaff, isDriver } = useAuth();
  if (isDriver) return <Navigate to="/app/driver" replace />;
  if (isStaff) return <Navigate to="/app/control-tower" replace />;
  return <Dashboard />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={site(<Home />)} />
          <Route path="/about" element={site(<About />)} />
          <Route path="/services" element={site(<Services />)} />
          <Route path="/industries" element={site(<Industries />)} />
          <Route path="/warehousing" element={site(<Warehousing />)} />
          <Route path="/cross-border" element={site(<CrossBorder />)} />
          <Route path="/sustainability" element={site(<Sustainability />)} />
          <Route path="/contact" element={site(<Contact />)} />
          <Route path="/track" element={site(<Track />)} />
          <Route path="/quote" element={site(<Quote />)} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payments/return" element={<PaymentResult mode="return" />} />
          <Route path="/payments/cancel" element={<PaymentResult mode="cancel" />} />
          <Route path="/pay/:id" element={<PayLink />} />

          <Route path="/app" element={<Protected><AppHome /></Protected>} />
          <Route path="/app/shipments" element={<Protected><Shipments /></Protected>} />
          <Route path="/app/shipments/:id" element={<Protected><ShipmentDetail /></Protected>} />
          <Route path="/app/quotes" element={<Protected><Quotes /></Protected>} />
          <Route path="/app/invoices" element={<Protected><Invoices /></Protected>} />
          <Route path="/app/locations" element={<Protected><Locations /></Protected>} />
          <Route path="/app/control-tower" element={<Protected><ControlTower /></Protected>} />
          <Route path="/app/route-ai" element={<Protected><RouteAI /></Protected>} />
          <Route path="/app/customs" element={<Protected><Customs /></Protected>} />
          <Route path="/app/alerts" element={<Protected><Alerts /></Protected>} />
          <Route path="/app/executive" element={<Protected><Executive /></Protected>} />
          <Route path="/app/fleet" element={<Protected><Fleet /></Protected>} />
          <Route path="/app/warehouse" element={<Protected><WarehouseOps /></Protected>} />
          <Route path="/app/finance" element={<Protected><Finance /></Protected>} />
          <Route path="/app/crossborder" element={<Protected><CrossBorderOps /></Protected>} />
          <Route path="/app/sustainability" element={<Protected><SustainabilityOps /></Protected>} />
          <Route path="/app/erp" element={<Protected><ErpConsole /></Protected>} />
          <Route path="/app/admin" element={<Protected><Admin /></Protected>} />
          <Route path="/app/driver" element={<Protected><Driver /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
